"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckNumbersRendererCms = void 0;
var CheckNumbersRendererCms = /** @class */ (function () {
    function CheckNumbersRendererCms() {
        this.lineAssignedLabel = 'Assigned to line';
        this.lineLabel = 'line';
    }
    return CheckNumbersRendererCms;
}());
exports.CheckNumbersRendererCms = CheckNumbersRendererCms;
//# sourceMappingURL=CheckNumbersRenderer.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/TransferForm/CheckedNumbersRenderer/CheckNumbersRenderer.cms.js
// module id = 2008
// module chunks = 8